<div class="tooltip-container">
  <span
    #tooltipTrigger
    class="tooltip-trigger"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    (focusin)="showTooltip()"
    (focusout)="hideTooltip()"
  >
    <ng-content></ng-content>
  </span>
</div>

<ng-template #tooltipBoxTemplate>
  <div
    class="tooltip-box {{ position() }}"
    [innerHTML]="tooltip()"
  ></div>
</ng-template>
